import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/portfolio/SmoothScroll";
import Portfolio from "@/pages/Portfolio";
import ErrorBoundary from "@/components/portfolio/ErrorBoundary";
import { RouteSkeleton } from "@/components/portfolio/Skeletons";
import { trackPageView } from "@/lib/analytics";
import { MotionConfig } from "framer-motion";
import AccentPicker from "@/components/portfolio/AccentPicker";

const BlogPost = lazy(() => import("@/pages/BlogPost"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const Admin = lazy(() => import("@/pages/Admin"));

/** Fires a GA4 page_view on every client-side route change. */
function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
    <div className="App grain min-h-screen bg-[#050505] text-[#fafafa]">
      <BrowserRouter>
        <AccentPicker />
        <PageViewTracker />
        <SmoothScroll>
          <ErrorBoundary>
          <Suspense fallback={<RouteSkeleton />}>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          </ErrorBoundary>
        </SmoothScroll>
        <Toaster theme="dark" position="bottom-right" richColors />
      </BrowserRouter>
    </div>
    </MotionConfig>
  );
}

export default App;

